import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Grid, Button, Card, CardContent, Switch } from '@mui/material';
import { Page, Header } from 'components';
import ClusterStringDialogForm from './components/ClusterStringDialogForm';
import SiteListDialogForm from './components/SiteListDialogForm';

import {
	SetFormState, GetClustersInfo, GetSiteListDates
} from '../actions/HostToolsActions';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(1),
	},
	tabs: {
		marginTop: theme.spacing(1),
	},
	content: {
		marginTop: theme.spacing(1),
	},
}));

const HostTools = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.hostToolsReducer.formState);
	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);

	useEffect(() => {
		dispatch(GetClustersInfo(userId));
		dispatch(GetSiteListDates(userId));
	}, []);

	return (
		<Page className={classes.root} title="Host Tools">
			<Header module="Modules" view="Host Tools" />
			<Grid className={classes.container} container spacing={1}>
				<Grid item lg={12} xs={12}>
					<ClusterStringDialogForm />
				</Grid>
				<Grid item lg={12} xs={12}>
					<SiteListDialogForm />
				</Grid>
			</Grid>
		</Page>
	);
};

export default HostTools;
